import { request } from '../utils/api';

export function GetBenefitsContent() {
  return request({
    method: "get",
    baseUrl: "api",
    route: 'beneficios/',
  })
}